<app-menu (menuWillOpen)="handleSideMenuOpen()"></app-menu>
<ion-tabs id="main-content">
  <ion-tab-bar slot="bottom" class="custom-tab-bar" [class.hidden]="!tabBarShown$$()">
    <ion-tab-button data-testid="cameras-tab-button" tab="cameras" (click)="handleGotoCameras()">
      <ion-icon name="tab-cameras" class="tab-icon"></ion-icon>
      {{ 'tabs.cameras' | transloco }}
    </ion-tab-button>

    <!-- Center FAB Tab Button with label -->
    <ion-tab-button class="fab-tab-button" (click)="handleFabLabelClick()">
      {{ (tabBarMenuOpen$$() ? 'tabs.fab.cancel' : 'tabs.fab.addNew') | transloco }}
    </ion-tab-button>

    <ion-tab-button data-testid="gallery-tab-button" tab="gallery" (click)="handleGotoGallery()">
      <ion-icon name="tab-gallery" class="tab-icon"></ion-icon>
      {{ 'tabs.gallery' | transloco }}
    </ion-tab-button>
  </ion-tab-bar>

  <!-- Center FAB - Respects same visibility as tab bar -->
  @if (tabBarShown$$()) {
    <app-tab-bar-fab [isMenuOpen]="tabBarMenuOpen$$()"></app-tab-bar-fab>
  }

  <!-- Menu Overlay - Shows when FAB is opened -->
  @if (tabBarMenuOpen$$()) {
    <app-tab-bar-menu-overlay
      [menuConfig]="menuConfig$$()"
      [expandedOptionId]="expandedOptionId$$()"
      (backdropClick)="handleBackdropClick()"
      (optionSelected)="handleMenuOptionClick($event)"
      (collapseOption)="handleExpandedOptionCollapse()"
    >
      <ng-container #bleAnchor></ng-container>
    </app-tab-bar-menu-overlay>
  }

  <app-offline-mode-sheet
    [open]="isOfflineModalVisible$$()"
    (closed)="handleOfflineModalClose()"
    (dismissed)="handleOfflineModalClose()"
    (updateStatus)="handleUpdateStatus()"
    (goToSystemSettings)="handleGoToSystemSettings()"
  ></app-offline-mode-sheet>

  <lib-coming-soon-modal [open]="isComingSoonModalVisible$$()" (closed)="handleComingSoonModalClose()" (dismissed)="handleComingSoonModalClose()"></lib-coming-soon-modal>

  <!-- Offline Banner -->
  <app-offline-banner></app-offline-banner>
</ion-tabs>
